import React from 'react';
import PropTypes from 'prop-types';
import {map} from 'lodash';
import Card from 'src/components/Cards/Card';
import CollapsibleSection from 'src/components/collapsible-section';

const propTypes = {
  college: PropTypes.shape({
    unsanitizedPartnerOngoingRequirements: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
};

const Rules = ({college}) => (
  <Card>
    <CollapsibleSection
      className="college-profile-requirements-card"
      title="Rules"
      trackIdentifier="college-listing-requirements-undergrad-scholarship-requirements"
    >
      <div className="college-profile-card-content">
        {map(college.unsanitizedPartnerOngoingRequirements, (requirement, index) => (
          <p key={index} dangerouslySetInnerHTML={{__html: requirement}}></p>
        ))}
      </div>
    </CollapsibleSection>
  </Card>
);

Rules.propTypes = propTypes;

export default Rules;
